import { defineMessages } from "react-intl";

export const spnGridMessages = defineMessages({
  expand: {
    defaultMessage: "Expand",
    id: "spn-grid-messages.expand",
  },
  selectServices: {
    defaultMessage: "Select Services",
    id: "spn-grid-messages.select-services",
  },
});
